module.exports = __webpack_public_path__ + "img/nicéphore-niépce.1cf62c38.png";